import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';

import { UseUIFeatureCheck } from '../types';

export { useShouldShowUserPublisher as useIsUserPublisherEnabled } from '@ms/yammer-hooks/dist/publishers';

export const useIsLongFormContentArticlePublisherEnabled: UseUIFeatureCheck = () =>
  useExperimentTreatmentWithoutReporting(Experiment.LongFormContentArticlePublisher) === 'enabled';
